import './About.css'

function About() {
  return (
    <section className="ko-about" id="about">
      <div className="about">
        <p>we are Ko-Tyat-Ki Kollektiv, London-Amsterdam-Berlin-NY-based techno-art collective exploring perception,
          inception &#38; conception. decentralised. fluid. we love code, LED & electronic music.
          doing multimedia art for purr-purr-purr :3</p>
        <p>we are artists, designers, architects, structural and software engineers.
          we’ve already successfully hippy-trapped many burners in a few iterations of the installation
          created for Nowhere, Midburn and other regionals. we created sound camps, stages and parties
          within the burn community. our camp-community MoonCows does regular free art+music collaboration events
          and a yearly nano-burn festival</p>
      </div>
    </section>
  )
}

export default About
